import template from './vat-type.jade';
import items from '../../../enums/vat-type';

import './vat-type.styl';

const DEFAULT_TYPE_INDEX = 1;

export default angular
    .module('cian.addForm.vatType', ['cian.addForm.fieldTypeDropdown'])
    .directive('cianAfPriceAndDealTermsVatType', () => ({
        scope: {},
        bindToController: {
            ad: '=?',
            form: '=?',
            customMessage: '=?',
            defaultValue: '=?',
        },
        controller($scope, categoryService) {
            'ngInject';

            this.items = items;

            const ad = this.ad || $scope.$root.ad;
            const { propertyType } = categoryService.getInfoByCategory(ad.category);

            if (propertyType === 'commercial') {
                this.defaultValue = items[DEFAULT_TYPE_INDEX].value;
                this.customMessage = 'К цене будет автоматически добавлен НДС 20%';
            }
        },
        controllerAs: 'vatType',
        template,
    }))
    .name;
